import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_USER_GLORIA,
  USER_LOGIN,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  user: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER_GLORIA:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        // loading: false,
        user: action.payload,
      }
      break
    case LOGOUT_USER:
      state = { ...state, loading: true }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case USER_LOGIN:
      state = { ...state, user: action.payload };
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
